var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload"},[_c('div',{staticClass:"upload-input",on:{"click":_vm.getFile}},[_c('div',{staticClass:"upload-btn"},[_vm._t("default")],2)]),_c('input',{ref:"fileUpload",staticClass:"fileUpload",attrs:{"accept":_vm.accepts,"type":"file","name":"file","title":" "},on:{"change":_vm.onChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }